import { Col, Row } from "@/app/components/lib/my-bootstrap";
import SvgMinus from "./quantity-selector-icons/SvgMinus";
import SvgPlus from "./quantity-selector-icons/SvgPlus";
import SvgRecycleBin from "./quantity-selector-icons/SvgRecycleBin";

interface Props {
  quantity: number;
  setQuantity: (count: number) => void;
  plusDisabled: boolean;
  flexColumn?: boolean;
  minQuantity?: number;
  disabled?: boolean;
  is_multi_select: boolean;
}

const AddonQuantitySelector: React.FC<Props> = ({
  quantity,
  setQuantity,
  plusDisabled,
  flexColumn,
  minQuantity,
  disabled,
  is_multi_select,
}) => {
  const minusDisabled = !is_multi_select && quantity > (minQuantity ?? 1);
  return (
    <Row
      className={`m-0 btn-quantity-selector align-items-center ${
        flexColumn ? "w-100" : ""
      }`}
    >
      {quantity > (minQuantity ?? 1) ? (
        <Col
          className="col-auto btn-icon"
          style={{ cursor: minusDisabled ? "not-allowed" : "pointer" }}
          onClick={
            !minusDisabled
              ? (e) => {
                  e.stopPropagation();
                  setQuantity(quantity - 1);
                }
              : undefined
          }
        >
          <SvgMinus disabled={minusDisabled} />
        </Col>
      ) : (
        <Col
          className="col-auto btn-icon"
          style={{ cursor: disabled ? "not-allowed" : "pointer" }}
          onClick={
            !disabled
              ? (e) => {
                  e.stopPropagation();
                  setQuantity(0);
                }
              : undefined
          }
        >
          <SvgRecycleBin disabled={disabled} />
        </Col>
      )}

      <Col className="p-0 d-flex justify-content-center">{quantity}</Col>
      <Col
        className="col-auto btn-icon"
        onClick={
          plusDisabled
            ? undefined
            : (e) => {
                e.stopPropagation();
                setQuantity(quantity + 1);
              }
        }
      >
        <SvgPlus disabled={plusDisabled} />
      </Col>
    </Row>
  );
};

export default AddonQuantitySelector;
